import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  margin-bottom: -3px;
  line-height: 0;
`;

/**
 * Circle progress bar.
 * Pass in either rate or rate as percentage.
 *
 * Based on https://stackoverflow.com/questions/29350504/circular-percent-progress-bar
 *  https://codepen.io/web-tiki/pen/qEGvMN
 */
export default function CircleProgressBar({
  percentage,
  rate,
  size,
}: {
  percentage?: number;
  rate?: number;
  size: number;
}) {
  const MAX = 251;

  const realRate = rate ? rate : (percentage || 0) / 100;
  const position = realRate * MAX + 1;

  const current = `${position},250.2`;
  const fullCircle = '251.2,0';

  const thickness = size < 50 ? 15 : size < 100 ? 10 : 5;

  return (
    <Svg viewBox="0 0 100 100" width={size}>
      <circle cx="50" cy="50" r="45" fill="transparent" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth={thickness}
        stroke="#242345"
        strokeDasharray={fullCircle}
        d="M50 10
           a 40 40 0 0 1 0 80
           a 40 40 0 0 1 0 -80"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth={thickness}
        stroke="var(--mainLight)"
        strokeDasharray={current}
        d="M50 10
           a 40 40 0 0 1 0 80
           a 40 40 0 0 1 0 -80"
      />
      {/* <text x="50" y="50" text-anchor="middle" dy="7" font-size="20">
        1%
      </text> */}
    </Svg>
  );
}
